// src/App.tsx
import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom'
import { Dashboard } from './components/Dashboard'
import { AdvancedDevices } from './components/AdvancedDevices'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/devices" element={<AdvancedDevices />} />
        <Route path="*" element={<Dashboard />} />
      </Routes>
    </Router>
  )
}

export default App
